import { useState } from "react";
import { Crown, ArrowRight } from "lucide-react";
import { Button } from "./ui/button";
import { motion } from "motion/react";
import { LoginSignup } from "./LoginSignup";
import { BookingPage } from "./BookingPage";
import { useAuth } from "../contexts/AuthContext";

export function CTABanner() {
  const { user } = useAuth();
  const [showLoginSignup, setShowLoginSignup] = useState(false);
  const [showBookingPage, setShowBookingPage] = useState(false);

  const handleBookNowClick = () => {
    if (user) {
      setShowBookingPage(true);
    } else {
      setShowLoginSignup(true);
    }
  };
  return (
    <section className="py-24 relative overflow-hidden bg-[#0f1f3d]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="text-center"
        >
          <Crown className="w-8 h-8 text-[#d4af37] mx-auto mb-6" aria-hidden="true" />

          <h2 className="text-white text-4xl lg:text-5xl mb-6 leading-tight">
            Ready to experience{" "}
            <span className="text-[#d4af37]">royal living?</span>
          </h2>

          <p className="text-white/80 text-xl max-w-2xl mx-auto mb-10 leading-relaxed">
            Rooms for the upcoming semester are filling up. Reserve your space at Majesty Hostel today.
          </p>

          <div className="flex justify-center">
            <Button
              size="lg"
              variant="gold"
              className="group text-lg px-10 py-6 rounded-lg shadow-lg"
              onClick={handleBookNowClick}
            >
              Book Your Room Now
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>
        </motion.div>
      </div>

      <LoginSignup
        open={showLoginSignup}
        onOpenChange={setShowLoginSignup}
        onSuccess={() => setShowBookingPage(true)}
      />
      <BookingPage open={showBookingPage} onOpenChange={setShowBookingPage} />
    </section>
  );
}